module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_9_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_9_before.jpg
// module id = 1210
// module chunks = 0